import type { Schemas } from '#shopware'

/**
 * Sorts product media by position field in ascending order
 * @param media - Array of ProductMedia objects
 * @returns Sorted array of ProductMedia (new array, does not mutate original)
 */
export function sortProductMedia(media: Schemas['ProductMedia'][] | undefined | null): Schemas['ProductMedia'][] | undefined {
    if (!media || !Array.isArray(media)) {
        return undefined
    }

    return [...media].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
}
